import { render, staticRenderFns } from "./ChecklistParameter.vue?vue&type=template&id=60936e76&scoped=true"
import script from "./ChecklistParameter.vue?vue&type=script&lang=js"
export * from "./ChecklistParameter.vue?vue&type=script&lang=js"
import style0 from "./ChecklistParameter.vue?vue&type=style&index=0&id=60936e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60936e76",
  null
  
)

export default component.exports